import * as React from "react"
import { Component } from "react"
import { Image } from "semantic-ui-react"
import DownloadIcon from "../../assets/images/DownloadIcon.png"
import * as uuid from "uuid"
import { withTranslation } from "react-i18next"

export class FileDownloadButton extends Component {
  constructor(props) {
    super(props)
    this.id = uuid.v1()
  }

  preventRefresh = (e) => {
    return false
  }

  render() {
    const { t } = this.props
    return (
      <div>
        <a
          className="link download-template"
          download
          href={this.props.downloadLink}
          target="_blank"
          rel="noopener"
          id={this.id}
          onClick={(e) => this.preventRefresh(e)}
        >
          {" "}
          {t("downloadTemplate")}{" "}
        </a>{" "}
        <Image src={DownloadIcon} className="vehicle-icons" />
      </div>
    )
  }
}

export default withTranslation("vehicle")(FileDownloadButton)
